import React, { useCallback, useContext, useEffect, useState } from 'react'
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Tooltip,
  Button,
  Modal,
  Box,
  Typography,
  Backdrop,
  CircularProgress,
  Autocomplete,
  Divider,
  Switch,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormGroup,
  Skeleton,
  Checkbox,
  Fab,
  Step,
  StepLabel,
  StepContent,
  Stepper,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Rating,
  TextField,
  Snackbar,
  Alert,
  List,
  ListItemAvatar,
  Avatar,
  AvatarGroup,
  Chip,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  LinearProgress,
} from "@mui/material";
import { MainContext } from '../../../context/main/main-context';
import { debounce } from 'lodash';
import DataHandler from '../../../handlers/DataHandler';
import MaterialCustomTablePagination from '../../../components/common/MaterialCustomTablePagination';
import AddSection from './modals/AddSection';


function SectionTab() {

  const { sections, fetchAllSections, templateMetaData } = useContext(MainContext);


  const [isOpen, setIsOpen] = useState(false)
  const [sectionLoading, setSectionLoading] = useState(false)
  const [currentSection, setCurrentSection] = useState(null)

  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const [state, setState] = useState({
    limit: 10,
    offset: 0,
    sort_column: 'created_at',
    sort_direction: 'DESC',
  });

  const handlePageChange = (event, newPage) => {

    const newOffset = newPage * rowsPerPage;

    setState((prevState) => ({
      ...prevState,
      limit: rowsPerPage,
      offset: newOffset
    }));
    setCurrentPage(newPage)

  };

  const handleRowsPerPageChange = (event) => {

    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(state.offset / newLimit);

    setState((prevState) => ({
      ...prevState,
      limit: newLimit,
      offset: newLimit * newPage
    }));
    setCurrentPage(newPage)

  };

  const handlePageOffsetChange = (newOffset, newPage) => {

    setState((prevState) => ({
      ...prevState,
      limit: rowsPerPage,
      offset: newOffset
    }));
    setCurrentPage(newPage)
  };

  const handlefetchAllSections = useCallback(
    debounce(async () => {
      const {
        limit,
        offset,
        sort_column,
        sort_direction
      } = state;

      const user_id = DataHandler.getFromSession('manage_user_id');


      setSectionLoading(true)

      try {

        await fetchAllSections(limit, offset, sort_column, sort_direction, user_id);

      } catch (error) {
        console.error('Error fetching templates:', error);
      } finally {
        setSectionLoading(false)
      }
    }, 300),
    [state]
  );

  const handleaddSection = () => {
    setIsOpen(true)
  }

  const updateSection = (sectionData) => {

    if (sectionData) {
      setCurrentSection(sectionData)
      setIsOpen(true)
    }

  }

  const closeUpdateModal = (value) => {
    setIsOpen(value)
    // handlefetchAllSections()
  }

  useEffect(() => {
    handlefetchAllSections()
  }, [state])

  useEffect(() => {

    if (sections && sections.success) {
      setSectionLoading(false)
    }
  }, [sections])

  const getPartNotationTypeById = (id) => {
    const notation = templateMetaData?.notations?.find(notation => notation.notation_id === id);
    return notation ? notation.notation_type : "N/A";
  };

  return (
    <Box>
      <Button sx={{ mt: 3, backgroundColor: '#63239A', borderRadius: '8px' }} onClick={handleaddSection} variant='contained'>
        Add New Section
      </Button>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className="thead">
            </TableCell>
            <TableCell
              className="thead"
              style={{ cursor: "pointer" }}
            >
              Section Notation{" "}
            </TableCell>
            <TableCell
              className="thead"
              style={{ cursor: "pointer" }}
            >
              Section Name{" "}
            </TableCell>
            <TableCell
              className="thead"
              style={{ cursor: "pointer" }}
            >
              Section Title{" "}
            </TableCell>
            <TableCell
              className="thead"
              style={{ cursor: "pointer" }}
            >
              Section Description{" "}

            </TableCell>
            {/* <TableCell
											className="thead"
											style={{ cursor: "pointer" }}
										>

											Number of Questions{" "}

										</TableCell> */}

            <TableCell
              className="thead"
              style={{ cursor: "pointer" }}
            >
              Status{" "}
            </TableCell>
            <TableCell className="thead">
              Section Actions
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {sections?.data?.sections && sections.data.sections.length > 0 && !sectionLoading ? (
            sections.data.sections.map((section, index) => (
              <TableRow key={index}>

                <TableCell className="tData"></TableCell>

                <TableCell className="tData">
                  <div className="center-vertical mg-m library-title">
                    {getPartNotationTypeById(section.notation_id) || ''}
                  </div>
                </TableCell>
                <TableCell className="tData">
                  <div className="center-vertical mg-m library-title">
                    {section.name || ''}
                  </div>
                </TableCell>
                <TableCell className="tData">
                  <div className="center-vertical mg-m library-title">
                    {section.title || ''}
                  </div>
                </TableCell>
                <TableCell className="tData">
                  <Tooltip title={section.description} placement="bottom-start" arrow>
                    <div className="center-vertical mg-m library-title">
                      {section.description || 'N/A'}
                    </div>
                  </Tooltip>
                </TableCell>

                {/* <TableCell className="tData">
													<div className="center-vertical mg-m library-title">
														{section.no_of_questions || '0'}
													</div>
												</TableCell> */}

                <TableCell className="tData">
                  <div className="center-vertical mg-m library-title">
                    {section?.status_id === 1 ? (
                      <Chip label="Active" color="success" />
                    )
                      :
                      (
                        <Chip label="InActive" color="error" />
                      )}
                  </div>
                </TableCell>

                <TableCell className="tData">
                  <Button
                    className="btn btn-icon action-btn  btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                    title="Edit Details"
                    onClick={() => updateSection(section)}
                  />
                </TableCell>

              </TableRow>
            ))
          ) : (
            sectionLoading ? (

              <TableRow>
                <TableCell colSpan={8}>
                  <Skeleton height={30} />
                  <Skeleton animation="wave" height={30} />
                  <Skeleton height={30} />
                  <Skeleton animation="wave" height={30} />
                  <Skeleton height={30} />
                  <Skeleton animation="wave" height={30} />
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <div>No Templates</div>
                </TableCell>
              </TableRow>
            )
          )}


        </TableBody>

      </Table>

      <div className="d-flex justify-content-end">
        <MaterialCustomTablePagination
          totalCount={sections?.data?.total_count || 0}
          currentPage={currentPage}
          limit={state.limit}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handlePageOffsetChange={handlePageOffsetChange}
          offset={state.offset}
          rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
        />
      </div>

      {isOpen &&
        <AddSection isOpen={isOpen} setIsOpen={closeUpdateModal} currentSection={currentSection} setCurrentSection={setCurrentSection} handlefetchAllSections={handlefetchAllSections} />
      }
    </Box>
  )
}

export default SectionTab